module.exports = __webpack_public_path__ + "static/media/0022_IMG_LES_ENSEIGNES_LE_TRAITEUR_SCRABBLE.91ac29c2.webp";